import React from 'react'
import { Link } from 'react-router-dom'
import SEO from '../components/SEO'
import { COMPANY_INFO } from '../data'

export default function ForbiddenPage() {
  return (
    <div className="min-h-[75vh] bg-[#0f1013] text-[#f4f3f0] flex items-center justify-center py-16 px-4">
      <SEO
        title="403 - Adgang nægtet | Docuit ink"
        description="Du har ikke adgang til denne ressource hos Docuit ink."
      />

      <div className="max-w-xl w-full bg-[#17191e] border border-[#282b34] rounded-2xl p-8 sm:p-12 text-center shadow-2xl">
        <span className="text-6xl sm:text-7xl font-serif font-extrabold text-red-500 block mb-2">
          403
        </span>
        <h1 className="text-2xl sm:text-3xl font-serif font-bold text-white mb-3">
          Adgang Nægtet
        </h1>
        <p className="text-neutral-400 text-sm leading-relaxed mb-8">
          Du har ikke tilladelse til at tilgå denne side eller ressource. Kontakt mig venligst, hvis du mener der er tale om en fejl.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Link
            to="/"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#cbb05e] hover:bg-[#d8be65] text-[#0f1013] font-bold uppercase tracking-wider text-xs rounded transition-colors"
          >
            <i className="fa-solid fa-house" aria-hidden="true" />
            Gå til Forside
          </Link>

          <Link
            to="/booking"
            className="w-full sm:w-auto inline-flex items-center justify-center gap-2 px-6 py-3 bg-neutral-900 border border-neutral-700 hover:border-neutral-500 text-white font-semibold uppercase tracking-wider text-xs rounded transition-colors"
          >
            Kontakt os
          </Link>
        </div>

        <div className="mt-8 pt-6 border-t border-neutral-800 text-xs font-mono text-neutral-400">
          Telefon: <a href={`tel:${COMPANY_INFO.phoneRaw}`} className="text-[#cbb05e] whitespace-nowrap hover:underline">{COMPANY_INFO.phone}</a> · E-mail: <a href={`mailto:${COMPANY_INFO.email}`} className="text-[#cbb05e] whitespace-nowrap hover:underline">{COMPANY_INFO.email}</a>
        </div>
      </div>
    </div>
  )
}
